import React from "react";
import {
    Box,
    Typography,
    Grid,
    Card,
    CardContent,
    CardActionArea,
    styled,
    keyframes
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {FaCartShopping} from "react-icons/fa6";
import {BiSolidOffer} from "react-icons/bi";
import {Domain, ListOutlined, Telegram, WhatsApp} from "@mui/icons-material";
import {BsMicrosoftTeams} from "react-icons/bs";
import {Can} from "../Can";

// Animation for card entrance
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

// Styled card component with hover effects
const ServiceCard = styled(Card)(({ theme }) => ({
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s, box-shadow 0.3s',
    animation: `${fadeIn} 0.5s ease-out`,
    '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: theme.shadows[8],
    },
}));

const CardTitle = styled(Typography)({
    fontWeight: 600,
    position: 'relative',
    paddingBottom: '8px',
    '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        width: '40px',
        height: '3px',
        backgroundColor: '#3f51b5',
    },
});

export const ManageServicesTable = () => {
    const navigate = useNavigate();

    // Card data - replace with your actual content
    const serviceCards = [
        { id: 1, title: "Our Services Management", path: "/Shop-ADS",icon : FaCartShopping,permission:'ourServices',action:'index' },
        { id: 2, title: "Offer Management", path: "/Offers" ,icon :BiSolidOffer,permission:'offers',action:'index' },
        { id: 3, title: "Smm Domains Management", path: "/SmmDomains" ,icon :Domain ,permission:'smmDomain',action:'index'},
        { id: 4, title: "Whatsapp Groups Management", path: "/WhatsappGroups" ,icon :WhatsApp ,permission:'whatsappGroups',action:'index'},
        { id: 5, title: "Telegram Groups Management", path: "/TelegramGroups" ,icon :Telegram,permission:'telegramGroups',action:'index' },
        { id: 6, title: "Teams Groups Management", path: "/skypeGroups" ,icon :BsMicrosoftTeams ,permission:'skypeGroups',action:'index'},
    ];

    const handleCardClick = (path: string) => {
        navigate(path);
    };

    return (
        <Box sx={{ flexGrow: 1, p: 3 }}>
            <Typography variant="h4" gutterBottom sx={{
                fontWeight: 700,
                mb: 4,
                textAlign: 'center',
                color: 'text.primary'
            }}>
                Manage Services
            </Typography>

            <Grid container spacing={3}>
                {serviceCards.map((card) => (
                    <Can I={card.action} a={card.permission}>
                    <Grid item xs={12} sm={6} md={4} key={card.id}>
                        <ServiceCard>
                            <CardActionArea
                                onClick={() => handleCardClick(card.path)}
                                sx={{ height: '100%', p: 2 }}
                            >
                                <CardContent sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center'
                                }}>
                                    {/* Placeholder for icon - replace with your actual icon */}
                                    <Box sx={{
                                        width: 64,
                                        height: 64,
                                        bgcolor: 'primary.main',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mb: 2,
                                        color: 'white',
                                        fontSize: '1.5rem'
                                    }}>
                                        {card.icon ? <card.icon className="" /> : card.title.charAt(0)}
                                    </Box>

                                    <CardTitle variant="h6" gutterBottom>
                                        {card.title}
                                    </CardTitle>

                                    <Typography variant="body2" color="text.secondary">
                                        Click to access {card.title.toLowerCase()}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </ServiceCard>
                    </Grid>
                    </Can>
                ))}
            </Grid>
        </Box>
    );
};